import React from 'react';
import { Loader, BaasicModal, BaasicButton, BaasicConfirmModal, Collapsible, BaasicHeader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';
import {
	ProductInventoryList,
	ProductHistoryLogList,
	AddExistingProductModalContent,
	UpdateProductPartModalContent,
} from 'modules/product/pages';
import UpdateInventoryLog from 'modules/product/pages/UpdateInventoryLog';
import { RestockDate } from 'modules/restock-date/pages';

const ProductDetailTemplate = ({ productDetailViewStore, t }) => {
	const {
		product,
		goToEdit,
		loading,
		convertedLenght,
		convertedHeight,
		convertedWidth,
		convertedWeight,
		dimensionUnit,
		showMore,
		toggleShowMore,
		textLimit,
		renderText,
		rootStore,
		addProductPartModal,
		openAddProductPartModal,
		addExistingProductModal,
		productPartsIds,
		onProductPartDelete,
		deleteProductPartModal,
		updateProductPartModal,
		selectedProductPart,
		onProductPartEdit,
		productPartsToShow,
		isWarehouse,
		updateInventoryLogModal,
		openUpdateInventoryLogModal,
		openEditRestockDateModal,
		scheduledRestockDate,
		hasAmazonVirtualSku,
	} = productDetailViewStore;
	if (loading) return <Loader />;
	return (
		<div className="container--fluid">
			<ReactTooltip />
			<BaasicHeader rootStore={rootStore} title={'PRODUCTDETAILVIEW.LABEL.PRODUCTDETAILS'}>
				{scheduledRestockDate && (
					<i
						data-tip={t('RESTOCKDATE.SCHEDULEDRESTOCKDATENOTE', { scheduledDate: scheduledRestockDate })}
						className="spc--right--sml far fa-clock type--color--success--light type--med"
					/>
				)}
				<div className="flex--primary">
					{/* Restock Date */}
					{!isWarehouse && hasAmazonVirtualSku && (
						<BaasicButton
							className="btn btn--med btn--primary btn--primary--negative spc--right--sml"
							icon="icon icon--xmed icon--inventory-update spc--right--sml"
							onClick={() => {
								openEditRestockDateModal();
							}}
							label="RESTOCKDATE.TITLE"
						/>
					)}
					{product.isMultiProduct && (
						<BaasicButton
							className="btn btn--white spc--right--sml"
							onClick={openAddProductPartModal}
							icon="fa fa-boxes spc--right--tny"
							authorization="productSection.update"
							label="PRODUCTDETAILVIEW.ADDPRODUCTPART"
						/>
					)}
					{!isWarehouse && (
						<BaasicButton
							className="btn btn--med btn--primary btn--primary--negative spc--right--sml"
							icon="icon icon--xmed icon--inventory-update spc--right--sml"
							onClick={() => {
								openUpdateInventoryLogModal();
							}}
							label="UPDATEINVENTORYLOG.TITLE"
						/>
					)}
					<BaasicButton
						className="btn btn--white"
						onClick={goToEdit}
						icon="fa fa-edit spc--right--tny"
						authorization="productSection.update"
						label="EDIT"
					/>
				</div>
			</BaasicHeader>
			<div className="order__wrapper">
				<div className="order__header">
					<div className="container--fluid">
						<div className="row">
							<div className="col col-sml-6 col-med-6 col-xlrg-3 col-xxlrg-3 spc--bottom--sml">
								<div className="order__header__item fullheight">
									<h4 className="order__header__title type--base">{t('PRODUCTDETAILVIEW.LABEL.SKU')}</h4>
									<p>{product.mainSku}</p>
								</div>
							</div>
							<div className="col col-sml-9 spc--bottom--sml">
								<div className="order__header__item fullheight">
									<h4 className="order__header__title type--base">{t('PRODUCTDETAILVIEW.LABEL.NAME')}</h4>
									<p>{product.name}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="order__details">
					<div className="container--fluid spc--bottom--lrg">
						<div className="order__box">
							<h4 className="order__box__title">{t('PRODUCTDETAILVIEW.LABEL.GENERALINFORMATION')}</h4>
							<div className="order__box__content">
								<div className="flex__wrapper">
									<div className="flex__column flex__column--image">
										<div className="order__header__item">
											<h4 className="order__header__title">{t('PRODUCTDETAILVIEW.LABEL.IMAGE')}</h4>
										</div>
										<div className="order__box__content">
											<img
												className="order__image order__image--lrg"
												src="https://milliardbedding.com/wp-content/uploads/2021/04/51104088640_40f294f443_o-scaled-700x700.jpg"
											></img>
										</div>
									</div>
									<div className="flex__column flex__column--information">
										<div>
											<div className="order__header__item">
												<h4 className="order__header__title">{t('PRODUCTDETAILVIEW.LABEL.PRODUCTINFORMATION')}</h4>
											</div>
											<div className="order__box__content">
												<div className="row">
													<div className="col col-sml-4">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.DIMENSIONS')}</p>
														<p>
															<span data-tip={convertedLenght} className="spc--right--tny">
																{product.length} x
															</span>
															<span data-tip={convertedWidth} className="spc--right--tny">
																{product.width} x
															</span>
															<span data-tip={convertedHeight} className="spc--right--tny">
																{product.height}
															</span>
															<span>{dimensionUnit}</span>
														</p>
													</div>
													<div className="col col-sml-8">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.WEIGHT')}</p>
														<p>
															<span data-tip={convertedWeight}>
																{product.detailWeight != undefined ? product.detailWeight : '-'}
															</span>
														</p>
													</div>
												</div>
												<div className="row">
													<div className="col col-sml-4">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.CONDITION')}</p>
														<p>{product.condition != null ? product.condition.name : '-'}</p>
													</div>
													<div className="col col-sml-8">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.PRODUCTCATEGORY')}</p>
														<p>{product.productCategory != null ? product.productCategory.name : '-'}</p>
													</div>
												</div>
												<div className="row">
													<div className="col col-sml-4">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.PRODUCTSTATUS')}</p>
														<p>{product.productStatus != null ? product.productStatus.name : '-'}</p>
													</div>
													<div className="col col-sml-8 type--break">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.DESCRIPTION')}</p>
														{product.description ? <p>{renderText()}</p> : null}
														{product.description.length > textLimit && (
															<a className="btn btn--base btn--ghost" onClick={toggleShowMore}>
																{showMore ? t('PRODUCTDETAILVIEW.SHOWLESS') : t('PRODUCTDETAILVIEW.SHOWMORE')}
															</a>
														)}
													</div>
												</div>
												<div className="row">
													<div className="col col-sml-4">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.UPC')}</p>
														{product.productUpcs.map((item, idx) => {
															return <p key={idx}>{item.upc}</p>;
														})}
													</div>
													<div className="col col-sml-8">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.ONEPERBOX')}</p>
														<p>{product.onePerBox ? 'Yes' : 'No'}</p>
													</div>
												</div>
												<div className="row">
													<div className="col col-sml-4">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.BOX')}</p>
														<p>{product.box != null ? product.box.name : '-'}</p>
													</div>
													<div className="col col-sml-8">
														<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.ASIN')}</p>
														<p>{product.asin}</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="flex__column flex__column--skus">
										<div className="row">
											<div className="col col-sml-12 spc--bottom--med">
												<div className="order__header__item">
													<h4 className="order__header__title">{t('PRODUCTDETAILVIEW.LABEL.PRODUCTVIRTUALSKU')}</h4>
												</div>
												<div className="order__box__content">
													<div className="row">
														<div className="col col-sml-4">
															<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.VIRTUALSKU')}</p>
														</div>
														<div className="col col-sml-4">
															<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.CHANNEL')}</p>
														</div>
														<div className="col col-sml-4">
															<p className="order__label spc--top--sml">{t('PRODUCTDETAILVIEW.LABEL.DESCRIPTION')}</p>
														</div>
													</div>
													{product.productVirtualSkus.map((productVirtualSku, idx) => {
														return (
															<div className="row" key={idx}>
																<div className="col col-sml-4">
																	<p>{productVirtualSku.sku}</p>
																</div>
																<div className="col col-sml-4">
																	<p>{productVirtualSku.channel.name}</p>
																</div>
																<div className="col col-sml-4">
																	<p>{productVirtualSku.description}</p>
																</div>
															</div>
														);
													})}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{product.isMultiProduct && product.multiPackageProducts.length > 0 && (
						<div className="order__box--no-padd spc--top--med">
							<Collapsible title={t('PRODUCTDETAILVIEW.LABEL.PRODUCTPARTS')}>
								<table className="table table--tertiary">
									<tbody>
										<tr>
											<th>{t('PRODUCTDETAILVIEW.LABEL.PRODUCTSKU')}</th>
											<th className="w--100--px">{t('PRODUCTDETAILVIEW.LABEL.QUANTITY')}</th>
											{!isWarehouse && <th className="w--100--px">{t('ACTIONS')}</th>}
										</tr>
										{productPartsToShow.map((product, idx) => {
											return (
												<tr key={idx}>
													<td>{product.mainSku}</td>
													<td>{product.quantity}</td>
													{!isWarehouse && (
														<td>
															<i
																title={t('EDIT')}
																className="fa fa-edit spc--right--sml k-custom-clickable"
																onClick={() => onProductPartEdit(product.extra)}
															></i>
															<i
																title={t('REMOVE')}
																className="fa fa-trash k-custom-clickable"
																onClick={() => onProductPartDelete(idx)}
															></i>
														</td>
													)}
												</tr>
											);
										})}
									</tbody>
								</table>
							</Collapsible>
						</div>
					)}

					<div className="order__box--no-padd spc--top--med">
						<Collapsible expanded={true} title={t('MAINMENU.INVENTORY.PAGETITLE')}>
							<ProductInventoryList productDetailViewStore={productDetailViewStore} />
						</Collapsible>
					</div>

					<div className="spc--top--med">
						<Collapsible title={t('LOGHISTORY')}>
							<ProductHistoryLogList />
						</Collapsible>
					</div>

					<BaasicConfirmModal modalParams={addProductPartModal} />
					<BaasicModal className="ReactModal--med" modalParams={addExistingProductModal}>
						<AddExistingProductModalContent currentPartsIds={productPartsIds} />
					</BaasicModal>
					<BaasicModal modalParams={productDetailViewStore.editRestockDateModal}>
						<RestockDate parentViewStore={productDetailViewStore} />
					</BaasicModal>
					<BaasicModal modalParams={updateProductPartModal}>
						<UpdateProductPartModalContent selectedProductPart={selectedProductPart} />
					</BaasicModal>
					<BaasicConfirmModal modalParams={deleteProductPartModal} />
					<BaasicModal className="ReactModal--lrg" modalParams={updateInventoryLogModal}>
						<UpdateInventoryLog parentViewStore={productDetailViewStore} />
					</BaasicModal>
				</div>
			</div>
		</div>
	);
};

export default defaultTemplate(ProductDetailTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/ProductDetailTemplate.jsx